<template>
  <v-container class="pa-0">
    <v-col
      class="text-center"
      cols="12"
    >
      <h1 class="text-h5">{{ list.name }}</h1>
    </v-col>
    <v-col cols="12">
      <v-row
        class="justify-center"
        wrap
      >
        <template v-if="products.length">
          <v-col
            v-for="product in products"
            :key="product.id"
            class="text-center"
            sm="2"
          >
            <product-button
              :product="product"
              color="grey lighten-3"
              @added-to-cart="$emit('added-to-cart')"
            />
          </v-col>
        </template>
        <template v-else>
          <v-progress-circular
            v-if="$wait.is(`fetching productlist ${list.id}`)"
            :size="25"
            :width="3"
            color="primary"
            indeterminate
          />
          <span v-else>{{ $t('No results found.') }}</span>
        </template>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import ProductButton from '@/components/checkout/ProductButton'
import productListService from '@/services/product-lists'
import camelcaseKeys from 'camelcase-keys'

export default {
  name: 'ProductListProducts',

  components: {
    ProductButton
  },

  props: {
    list: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    products: []
  }),

  created () {
    this.$wait.start(`fetching productlist ${this.list.id}`)
    productListService.getProducts(this.list.id)
      .then((data) => {
        this.products = camelcaseKeys(data.data.products, { deep: true })
      })
      .finally(() => this.$wait.end(`fetching productlist ${this.list.id}`))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/checkout/ProductListProducts.vue